import { useTranslation } from '@eti/providers';
import { ONLINE_CHECK_IN } from '../../products';
import getTranslatedTexts from '../../common/text-resolvers/utils/getTranslatedTexts';
import SmallCardLayout from '../../common/components/small-card-layout/SmallCardLayout';
import { jsx as _jsx } from "react/jsx-runtime";
const texts = {
  readMoreContent: 'onlineCheckInReadMoreModalContent',
  text: 'onlineCheckInAbstractSmallCard',
  title: 'onlineCheckInTitle'
};
const SmallSms = _ref => {
  let {
    form,
    isSelected,
    order,
    layoutType
  } = _ref;
  const {
    t
  } = useTranslation();
  const {
    text,
    readMoreContent,
    title
  } = getTranslatedTexts(texts, t);
  return /*#__PURE__*/_jsx(SmallCardLayout, {
    description: text,
    form: form,
    isSelected: isSelected,
    layoutType: layoutType,
    order: order,
    productId: ONLINE_CHECK_IN.id,
    productName: ONLINE_CHECK_IN.name,
    readMoreContent: readMoreContent,
    title: title
  });
};
export default SmallSms;
//# sourceMappingURL=SmallOnlineCheckIn.js.map